import { topliApi } from "@/shared/api/topli/TopliApi"
import { useQuery } from "@tanstack/react-query"

export const defaultManagerQueryKey = 'defaultManagerQueryGet'

export const getDefaultManager = async () => {
  const response = await topliApi.defaultManager.get()
  return response
}

export const useDefaultManager = () => useQuery({
    queryKey: [defaultManagerQueryKey],
    queryFn: getDefaultManager,
  })